import { ALGOLIA_CLIENT } from '@/config/algolia.config'

export const search = async ({ index, params }) => {
  const defaultParams = {
    length: 50,
    offset: 0,
    ...params,
  }
  const result = await index.search('', defaultParams)
  return result
}

export const searchMultipleQueries = async ({ params }) => {
  const result = await ALGOLIA_CLIENT.multipleQueries(params)
  return result
}
